<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.shiftSettings')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{$ml.get('shared.settings')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.shiftSettings')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>Vardiya (Shift) Plan Ayarları</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Çalışma Tipi</label>
                    <select @change="changeShiftMode($event)" class="form-control">
                      <option :selected="webshiftSettings.shiftMode == 0" value="0">Seçiniz</option>
                      <option :selected="webshiftSettings.shiftMode == 1" value="1">Haftalık</option>
                      <option :selected="webshiftSettings.shiftMode == 2" value="2">Aylık</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Onay başlangıç günü (Plan kilitleme günü)</label>
                    <select class="form-control">
                      <option
                        v-for="day in dayList"
                        :key="day.value"
                        :value="day.value"
                        :selected="day.value == webshiftSettings.shiftConfirmStartDay"
                      >{{day.name}}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Aynı haftaya girilebilir maksimum izin sayısı</label>
                    <input
                      v-model="webshiftSettings.allowenceLimitPerWeek"
                      type="number"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label>Geriye dönük planlama sınırı (Maksimum gün)</label>
                    <input
                      v-model="webshiftSettings.changeShiftDayLimit"
                      type="number"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Planlama Onay Durumu</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input
                          :checked="webshiftSettings.isConfirmActive"
                          @change="webshiftSettings.isConfirmActive==true ? webshiftSettings.isConfirmActive=false : webshiftSettings.isConfirmActive=true"
                          type="checkbox"
                        />
                        Onay gerekli
                      </label>
                    </span>
                  </div>
                  <div class="form-group">
                    <label>Onaylanmamış Plan Uyarısı</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input
                          :checked="webshiftSettings.mailToFirstAuthorizedPerson"
                          @change="webshiftSettings.mailToFirstAuthorizedPerson==true ? webshiftSettings.mailToFirstAuthorizedPerson=false : webshiftSettings.mailToFirstAuthorizedPerson=true"
                          type="checkbox"
                        />
                        Onaylanmamış plan olduğunda uyarı e-postası gönderilsin
                      </label>
                    </span>
                  </div>
                  <div class="form-group">
                    <label>Onaylanmamış Plan Uyarı Tekrarı</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input
                          :checked="webshiftSettings.mailToSecondAuthorizedPerson"
                          @change="webshiftSettings.mailToSecondAuthorizedPerson==true ? webshiftSettings.mailToSecondAuthorizedPerson=false : webshiftSettings.mailToSecondAuthorizedPerson=true"
                          type="checkbox"
                        />
                        Onaylanmamış plan tekrarı olduğunda uyarı e-postası gönderilsin
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  @click="setSetting()"
                  type="button"
                  class="btn btn-sm btn-success"
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      webshiftSettings: {
        id: 0,
        shiftMode: 0, //Aylık - Haftalık
        allowenceLimitPerWeek: 0, //Aynı haftaya maksimum girilebilir izin sayısı
        changeShiftDayLimit: 0, //Geriye dönük planlama sınırı
        isConfirmActive: true, //Onay gerekli mi?
        mailToFirstAuthorizedPerson: true, //Uyarı maili aktif
        mailToSecondAuthorizedPerson: true, //Uyarı tekrarı maili (ertesi gün)
        shiftConfirmStartDay: 0 //Onay başlangıç günü
      },
      days: [
        { value: 1, name: this.$ml.get("general.monday"), check: true },
        { value: 2, name: this.$ml.get("general.tuesday"), check: true },
        { value: 3, name: this.$ml.get("general.wednesday"), check: true },
        { value: 4, name: this.$ml.get("general.thursday"), check: true },
        { value: 5, name: this.$ml.get("general.friday"), check: true },
        { value: 6, name: this.$ml.get("general.saturday"), check: true },
        { value: 7, name: this.$ml.get("general.sunday"), check: true }
      ]
    };
  },
  computed: {
    dayList() {
      return this.days;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    changeShiftMode(event) {
      this.webshiftSettings.shiftMode = event.target.value;
    },
    async setSetting() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .post("/WebshiftSettings", this.webshiftSettings)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async getShiftSetting() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get("WebshiftSettings")
          .then(response => {
            this.webshiftSettings = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getShiftSetting();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/shiftManagement/ShiftSettings.vue